@if (largeView) {
  <ul class="nav nav-tabs mb-4">
    <div id="reportTabs" class="d-flex">
      <li class="nav-item" (click)="changeTab(uiTabs.tab1)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab1">{{
          uiTabs.tab1
        }}</a>
      </li>
      <li class="nav-item" (click)="changeTab(uiTabs.tab2)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab2">{{
          uiTabs.tab2
        }}</a>
      </li>
    </div>
    <li class="nav-item" (click)="changeTab(uiTabs.tab3)">
      <a class="nav-link" [class.active]="activeTab === uiTabs.tab3">{{
        uiTabs.tab3
      }}</a>
    </li>
    @if (userPrompts?.length) {
      <li class="nav-item" (click)="changeTab(uiTabs.tab4)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab4">{{
          uiTabs.tab4
        }}</a>
      </li>
    }
    <div id="configuredReportsTab" class="d-flex">
      <li
        class="nav-item"
        (click)="changeTab(uiTabs.tab5)"
        id="configuredReportTab"
      >
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab5">{{
          uiTabs.tab5
        }}</a>
      </li>
    </div>
    <div id="analyticsTab" class="d-flex">
      <li class="nav-item" (click)="changeTab(uiTabs.tab6)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab6">{{
          uiTabs.tab6
        }}</a>
      </li>
    </div>
    <div id="timeSheetTab" class="d-flex">
      <li class="nav-item" (click)="changeTab(uiTabs.tab7)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab7">{{
          uiTabs.tab7
        }}</a>
      </li>
    </div>
    <div class="d-flex">
      <li class="nav-item" (click)="changeTab(uiTabs.tab8)">
        <a class="nav-link" [class.active]="activeTab === uiTabs.tab8">{{
          uiTabs.tab8
        }}</a>
      </li>
    </div>
  </ul>
} @else {
  <div class="mb-2" id="reportTabs">
    <select
      class="form-select form-select-lg"
      (change)="selectDropDown($event)"
      [value]="activeTab"
    >
      @for (tab of uiTabs | keyvalue; track tab) {
        @if (userPrompts?.length || uiTabs.tab4 !== tab.value) {
          <option [value]="tab.value">
            {{ tab.value }}
          </option>
        }
      }
    </select>
  </div>
}

<div class="tab-content">
  @if (activeTab === uiTabs.tab1) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab1 ? 'active' : ''">
      <gtapp-jobs-report></gtapp-jobs-report>
    </div>
  }
  @if (activeTab === uiTabs.tab2) {
    <gtapp-patrol-report
      (closeTab)="changeTab(uiTabs.tab1)"
    ></gtapp-patrol-report>

    <!--TODO: remove this after testing-->
    <div
      class="tab-pane d-none"
      [ngClass]="activeTab === uiTabs.tab2 ? 'active' : ''"
    >
      @if (!selectedEvent || largeView) {
        <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
      }
      @if (
        reportSiteClientLookup?.client?.data?.id ||
        reportSiteClientLookup?.site?.data?.id
      ) {
        @if (previewPatrolReport) {
          <ng-container>
            @if (previewReportData?.patrol_detail?.is_subcontracting) {
              <div
                class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
              >
                {{
                  reportSiteClientLookup?.client?.data?.company_name ||
                    reportSiteClientLookup?.site?.data?.company?.company_name
                }}
                is a Prime Contractor
              </div>
            }
            <div class="p-lg-5 p-2 report-preview shadow bg-white text-black">
              <div
                class="d-flex gap-3 gap-lg-5 border border-1 rounded mb-2 py-2 px-1 showHideControls flex-wrap"
              >
                <div class="fw-semibold small">Show/Hide</div>
                <div>
                  <div
                    (click)="
                      previewReportDataAdditionalInfo.hide_header =
                        !previewReportDataAdditionalInfo?.hide_header
                    "
                    role="button"
                    [ngClass]="
                      previewReportDataAdditionalInfo?.hide_header
                        ? 'opacity-50'
                        : 'text-primary'
                    "
                    class="small"
                  >
                    Header
                  </div>
                </div>
                @if (!previewReportDataAdditionalInfo.hide_header) {
                  <div>
                    <div
                      (click)="
                        previewReportDataAdditionalInfo.hide_subscriber_header_details =
                          !previewReportDataAdditionalInfo?.hide_subscriber_header_details
                      "
                      role="button"
                      [ngClass]="
                        previewReportDataAdditionalInfo?.hide_subscriber_header_details
                          ? 'opacity-50'
                          : 'text-primary'
                      "
                      class="small"
                    >
                      Company Address
                    </div>
                  </div>
                }
                @if (
                  previewReportData?.patrol_detail?.address ||
                  previewReportData?.patrol_detail?.custom_address
                ) {
                  <div>
                    <div
                      (click)="
                        previewReportDataAdditionalInfo.hide_client_detail =
                          !previewReportDataAdditionalInfo?.hide_client_detail
                      "
                      role="button"
                      [ngClass]="
                        previewReportDataAdditionalInfo?.hide_client_detail
                          ? 'opacity-50'
                          : 'text-primary'
                      "
                      class="small"
                    >
                      {{
                        reportSiteClientLookup?.site?.data?.id
                          ? "Site Address"
                          : "Client Address"
                      }}
                    </div>
                  </div>
                }
              </div>
              <ng-container>
                @if (!previewReportDataAdditionalInfo?.hide_header) {
                  <div class="header-container">
                    <div class="subscriber_company_information_section">
                      @if (
                        !previewReportDataAdditionalInfo?.hide_subscriber_header_details
                      ) {
                        <div class="strong">
                          {{
                            previewReportData?.patrol_detail?.subscriber_info
                              ?.name
                          }}
                        </div>
                        <div>
                          {{
                            previewReportData?.patrol_detail?.subscriber_info
                              ?.address
                          }}
                        </div>
                        <div>
                          {{
                            previewReportData?.patrol_detail?.subscriber_info
                              ?.city
                          }}
                        </div>
                        @if (
                          previewReportData?.patrol_detail?.subscriber_info
                            ?.mobile_number
                        ) {
                          <div>
                            Ph:
                            {{
                              previewReportData?.patrol_detail?.subscriber_info
                                ?.mobile_number
                            }}
                          </div>
                        }
                        <div>
                          {{
                            previewReportData?.patrol_detail?.subscriber_info
                              ?.email
                          }}
                        </div>
                      }
                    </div>
                    <div class="text-center">
                      @if (
                        previewReportData?.patrol_detail?.subscriber_info
                          ?.logo_url
                      ) {
                        <img
                          [ngClass]="
                            largeView ? 'logo_img_large' : 'logo_img_mob'
                          "
                          alt="placeholder_logo"
                          src="{{
                            previewReportData?.patrol_detail?.subscriber_info
                              ?.logo_url
                          }}"
                        />
                        <div
                          (click)="modifyLetterHeadLogo()"
                          role="button"
                          class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
                        >
                          Update Logo
                        </div>
                      } @else {
                        <div
                          (click)="modifyLetterHeadLogo()"
                          role="button"
                          class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
                        >
                          Upload Logo
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="report-type-heading">Patrol Report</div>
                <!--CLIENT INFORMATION SECTION-->
                <div class="client_information_section">
                  <div>
                    {{ previewReportData?.patrol_detail?.client }}
                  </div>
                  @if (!previewReportDataAdditionalInfo?.hide_client_detail) {
                    @if (previewReportData?.patrol_detail?.custom_address) {
                      <div class="gt-multi-line">
                        {{ previewReportData?.patrol_detail?.custom_address }}
                      </div>
                    }

                    <div>
                      {{ previewReportData?.patrol_detail?.address }}
                    </div>

                    <div>
                      {{ previewReportData?.patrol_detail?.city }}
                    </div>
                  }
                </div>
                <div class="patrol-table mt-5">
                  @if (
                    previewReportData?.patrol_detail?.time_zone &&
                    previewReportData?.patrol_detail?.time_zone_diff
                  ) {
                    <div
                      style="
                        font-size: 10px;
                        padding-bottom: 0.5rem;
                        color: #333;
                        font-weight: bold;
                        font-style: italic;
                      "
                    >
                      Timestamps shown in
                      {{ previewReportData?.patrol_detail?.time_zone }}
                      {{ previewReportData?.patrol_detail?.time_zone_diff }}
                    </div>
                  }
                  <!--PATROL TABLE SECTION-->
                  @if (previewReportData?.patrol_detail?.report_date) {
                    <div style="font-size: 10px; padding-bottom: 0.5rem">
                      <div>
                        Report Generated
                        {{ previewReportData?.patrol_detail?.report_date }}
                      </div>
                      @if (timeFilterRange?.start && timeFilterRange?.end) {
                        <div>
                          Showing Records Between
                          {{
                            timeFilterRange?.start | date: "dd MMM yyyy HH:mm"
                          }}
                          to
                          {{ timeFilterRange?.end | date: "dd MMM yyyy HH:mm" }}
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (totalRows) {
                  <div class="mt-2">
                    <gtapp-pagination-control
                      [pageSize]="pageSize"
                      [pageNum]="pageNum"
                      [previous]="previous"
                      [totalRows]="totalRows"
                      (onChangePagination)="onChangePreviewPagination($event)"
                    >
                    </gtapp-pagination-control>
                  </div>
                }
                <div class="mb-3 border border-1 rounded p-1">
                  <div class="fw-semibold small px-2">Show/Hide</div>
                  <div
                    class="d-flex gap-3 gap-lg-5 px-2 py-2 showHideControls flex-wrap"
                  >
                    <div
                      (click)="
                        previewReportDataAdditionalInfo.hide_uploads =
                          !previewReportDataAdditionalInfo?.hide_uploads;
                        filterSummaryData()
                      "
                      role="button"
                      [ngClass]="
                        previewReportDataAdditionalInfo?.hide_uploads
                          ? 'opacity-50'
                          : 'text-primary'
                      "
                      class="small"
                    >
                      Photo Events
                    </div>
                    <div>
                      <div
                        (click)="
                          previewReportDataAdditionalInfo.hide_guard_column =
                            !previewReportDataAdditionalInfo?.hide_guard_column
                        "
                        role="button"
                        [ngClass]="
                          previewReportDataAdditionalInfo?.hide_guard_column
                            ? 'opacity-50'
                            : 'text-primary'
                        "
                        class="small"
                      >
                        Guard Names
                      </div>
                    </div>
                    <div>
                      <div
                        (click)="
                          showSummaryOnly = !showSummaryOnly;
                          showCheckpointScanLocation = false
                        "
                        role="button"
                        [ngClass]="
                          !showSummaryOnly ? 'opacity-50' : 'text-primary'
                        "
                        class="small"
                      >
                        Summary Only
                      </div>
                    </div>
                    @if (qrNfcScanExists) {
                      <div>
                        <div
                          (click)="
                            showCheckpointScanLocation =
                              !showCheckpointScanLocation;
                            showSummaryOnly = false
                          "
                          role="button"
                          [ngClass]="
                            !showCheckpointScanLocation
                              ? 'opacity-50'
                              : 'text-primary'
                          "
                          class="small"
                        >
                          Scan Locations (QR/NFC)
                        </div>
                      </div>
                    }
                  </div>
                </div>
                @if (previewReportSummaryData?.length) {
                  @if (largeView) {
                    <div class="patrol-table mb-5">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th class="text-center">ID</th>
                            <th>Time</th>
                            <th>Event Type</th>
                            <th style="border-left: hidden"></th>
                            @if (
                              !previewReportDataAdditionalInfo?.hide_guard_column
                            ) {
                              <th>Guard</th>
                            }
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (
                            row of previewReportSummaryData;
                            track row;
                            let i = $index
                          ) {
                            <tr id="section_up{{ i + 1 }}">
                              <td
                                [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                                class="text-center"
                              >
                                {{ i + 1 }}
                              </td>
                              <td
                                [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                              >
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    {{
                                      row?.updated_datetime
                                        | date: "dd MMM yyyy HH:mm"
                                    }}
                                  </div>
                                  <div
                                    (click)="
                                      editEventTimeStamp(
                                        row,
                                        eventTimepStampUpdateTemplateRef
                                      )
                                    "
                                  >
                                    <i
                                      class="fa-solid fa-pen-to-square fa-2x text-secondary me-3"
                                    ></i>
                                  </div>
                                </div>
                              </td>
                              <td
                                [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                                class="uppercase line-height"
                              >
                                @if (
                                  row?.file ||
                                  ([6, 12].includes(row?.event_action) &&
                                    showCheckpointScanLocation)
                                ) {
                                  <a
                                    class="cursor-pointer"
                                    (click)="
                                      scrollToSection(
                                        $event,
                                        'section_down' + (i + 1)
                                      )
                                    "
                                    style="color: #00538d"
                                  >
                                    {{ row?.action }}
                                  </a>
                                } @else {
                                  {{ row?.action }}
                                }
                              </td>
                              <td
                                [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                                style="border-left: hidden"
                              >
                                <div class="d-flex">
                                  <div>
                                    <div class="gt-multi-line line-height fs-6">
                                      {{ row?.detail }}
                                    </div>
                                    @if (row?.prompts?.length) {
                                      @for (item of row?.prompts; track item) {
                                        <div class="mb-2">
                                          @for (
                                            dataItem of item?.data;
                                            track dataItem
                                          ) {
                                            @if (dataItem?.show_in_reports) {
                                              <div>
                                                <ng-template
                                                  *ngTemplateOutlet="
                                                    promptTemplate;
                                                    context: { value: dataItem }
                                                  "
                                                ></ng-template>
                                              </div>
                                            }
                                          }
                                        </div>
                                      }
                                    }
                                  </div>
                                  @if ([1, 2, 7].includes(row?.event_action)) {
                                    <div
                                      (click)="
                                        openCommentTemplate(commentRef, row)
                                      "
                                    >
                                      @if (row?.detail) {
                                        <span>
                                          <i
                                            class="fa-solid fa-pen-to-square fa-2x text-secondary ms-2"
                                          ></i>
                                        </span>
                                      } @else {
                                        <button
                                          class="btn btn-secondary btn-sm"
                                        >
                                          Add Remarks
                                        </button>
                                      }
                                    </div>
                                  }
                                </div>
                              </td>
                              @if (
                                !previewReportDataAdditionalInfo?.hide_guard_column
                              ) {
                                <td
                                  [ngClass]="
                                    row?.is_deleted ? 'opacity-25' : ''
                                  "
                                >
                                  {{ row?.user_name }}
                                </td>
                              }
                              <td>
                                @if ([1, 2, 7].includes(row?.event_action)) {
                                  <div
                                    class="ms-1"
                                    (click)="
                                      deleteRestoreUserUpdate({
                                        event: row,
                                        type: row?.is_deleted
                                          ? 'restore'
                                          : 'delete',
                                      })
                                    "
                                  >
                                    @if (row?.is_deleted) {
                                      <span>
                                        <i
                                          class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                                        ></i>
                                      </span>
                                    } @else {
                                      <span>
                                        <i
                                          class="fs-5 fa-solid fa-circle-minus text-danger"
                                        ></i>
                                      </span>
                                    }
                                  </div>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  } @else {
                    <table class="table table-responsive mb-5">
                      <tbody>
                        @for (
                          row of previewReportSummaryData;
                          track row;
                          let i = $index
                        ) {
                          <tr id="section_up{{ i + 1 }}">
                            <td class="bg-light text-dark">
                              <div class="d-flex justify-content-between">
                                <div
                                  class="line-height small text-secondary d-flex"
                                  [ngClass]="
                                    row?.is_deleted ? 'opacity-25' : ''
                                  "
                                >
                                  {{
                                    row?.updated_datetime
                                      | date: "dd MMM yyyy HH:mm"
                                  }}
                                  <span
                                    (click)="
                                      editEventTimeStamp(
                                        row,
                                        eventTimepStampUpdateTemplateRef
                                      )
                                    "
                                    class="ms-2"
                                    ><i
                                      class="fa-2x fa-solid fa-pen-to-square text-secondary"
                                    ></i
                                  ></span>
                                </div>
                                @if ([1, 2, 7].includes(row?.event_action)) {
                                  <div
                                    class="ms-1"
                                    (click)="
                                      deleteRestoreUserUpdate({
                                        event: row,
                                        type: row?.is_deleted
                                          ? 'restore'
                                          : 'delete',
                                      })
                                    "
                                  >
                                    @if (row?.is_deleted) {
                                      <span>
                                        <i
                                          class="fa-2x fa-solid fa-trash-can-arrow-up text-secondary"
                                        ></i>
                                      </span>
                                    } @else {
                                      <span>
                                        <i
                                          class="fa-2x fa-regular fa-trash-can text-secondary"
                                        ></i>
                                      </span>
                                    }
                                  </div>
                                }
                              </div>
                              <div
                                class="d-flex justify-content-between small text-secondary"
                              >
                                <div
                                  [ngClass]="
                                    row?.is_deleted ? 'opacity-25' : ''
                                  "
                                  class="uppercase line-height"
                                >
                                  @if (
                                    row?.file ||
                                    ([6, 12].includes(row?.event_action) &&
                                      showCheckpointScanLocation)
                                  ) {
                                    <a
                                      class="cursor-pointer"
                                      (click)="
                                        scrollToSection(
                                          $event,
                                          'section_down' + (i + 1)
                                        )
                                      "
                                      style="color: #00538d"
                                    >
                                      {{ row?.action }}
                                    </a>
                                  } @else {
                                    {{ row?.action }}
                                  }
                                </div>
                                @if (
                                  !previewReportDataAdditionalInfo?.hide_guard_column
                                ) {
                                  <div
                                    [ngClass]="
                                      row?.is_deleted ? 'opacity-25' : ''
                                    "
                                  >
                                    {{ row?.user_name }}
                                  </div>
                                }
                              </div>
                              <div
                                [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                              >
                                <div class="d-flex pt-2">
                                  <pre class="multi-line line-height fs-6">{{
                                    row?.detail
                                  }}</pre>
                                  @if ([1, 2, 7].includes(row?.event_action)) {
                                    <div
                                      (click)="
                                        openCommentTemplate(commentRef, row)
                                      "
                                    >
                                      @if (row?.detail) {
                                        <span>
                                          <i
                                            class="fa-2x fa-solid fa-pen-to-square text-secondary ms-2"
                                          ></i>
                                        </span>
                                      } @else {
                                        <button
                                          class="btn btn-secondary btn-sm"
                                        >
                                          Add Remarks
                                        </button>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                }

                <!-- DETAILS SECTION -->
                @if (!showSummaryOnly) {
                  <div class="mb-5">
                    @for (item of userEvents; track item; let i = $index) {
                      @if (
                        (item?.file ||
                          ([6, 12].includes(item?.event_action) &&
                            showCheckpointScanLocation)) &&
                        !item?.is_deleted
                      ) {
                        <div id="section_down{{ i + 1 }}">
                          @if (item?.file) {
                            <ng-container>
                              <div class="d-flex mb-2">
                                <div
                                  [ngClass]="
                                    largeView
                                      ? 'w-25 small pe-1 pb-3'
                                      : 'w-50 small pe-1 pb-3'
                                  "
                                >
                                  @if (item?.download_url) {
                                    <a
                                      href="{{ item.download_url }}"
                                      style="text-decoration: none"
                                    >
                                      <button
                                        class="btn btn-primary btn-sm mb-3"
                                      >
                                        Download Video
                                      </button>
                                    </a>
                                  }
                                  <!--TIMESTAMP-->
                                  <div
                                    style="font-weight: 600"
                                    class="key-value d-flex gap-1"
                                  >
                                    {{
                                      item?.updated_datetime
                                        | date: "dd MMM yyyy HH:mm"
                                    }}
                                    <span
                                      (click)="
                                        editEventTimeStamp(
                                          item,
                                          eventTimepStampUpdateTemplateRef
                                        )
                                      "
                                      ><i
                                        class="fa-solid fa-pen-to-square text-secondary fs-4"
                                      ></i
                                    ></span>
                                    @if (
                                      [1, 2, 7].includes(item?.event_action)
                                    ) {
                                      <span
                                        class="ms-1"
                                        (click)="
                                          deleteRestoreUserUpdate({
                                            event: item,
                                            type: item?.is_deleted
                                              ? 'restore'
                                              : 'delete',
                                          })
                                        "
                                      >
                                        @if (item?.is_deleted) {
                                          <span>
                                            <i
                                              class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                                            ></i>
                                          </span>
                                        } @else {
                                          <span>
                                            <i
                                              class="fa-solid fa-circle-minus text-danger fs-4"
                                            ></i>
                                          </span>
                                        }
                                      </span>
                                    }
                                  </div>
                                  <!-- GPS ACCURACY NOTIFICATION-->
                                  @if (item?.gps?.source) {
                                    <div class="warning distance">
                                      @if (item?.gps?.source == 1) {
                                        Location may not be accurate.
                                      } @else if (item?.gps?.source == 2) {
                                        Location is an approximation only.
                                      }
                                    </div>
                                  }
                                  <!--SECTION: EVENT LOCATION-->
                                  @if (item?.gps?.lat && item?.gps?.lon) {
                                    <div style="margin-bottom: 2rem">
                                      <div class="key-label text-secondary">
                                        Event Location
                                      </div>
                                      <div
                                        style="
                                          max-width: 100%;
                                          height: 150px;
                                          object-fit: none;
                                        "
                                        class="small"
                                      >
                                        <gtapp-map-leaflet
                                          [customMapConfig]="{
                                            showSimpleStaticMap: true,
                                          }"
                                          [latLon]="{
                                            markerTooltip: item?.event_by,
                                            lat: item?.gps?.lat,
                                            lon: item?.gps?.lon,
                                          }"
                                          [mapId]="'map_' + i"
                                        ></gtapp-map-leaflet>
                                      </div>
                                    </div>
                                  }
                                  <!--SECTION:  PHOTO COMMENT/NOTES-->
                                  <div class="d-inline">
                                    <div class="gt-multi-line">
                                      @if (item?.detail) {
                                        <span>
                                          {{ item?.detail }}
                                        </span>
                                      }
                                      @if (
                                        [1, 2, 7].includes(item?.event_action)
                                      ) {
                                        <span class="ms-auto">
                                          @if (item?.detail) {
                                            <span
                                              (click)="
                                                openCommentTemplate(
                                                  commentRef,
                                                  item
                                                )
                                              "
                                            >
                                              <i
                                                class="fa-solid fa-pen-to-square text-secondary mx-2 fs-4"
                                              ></i>
                                            </span>
                                            <span (click)="deleteComment(item)">
                                              <i
                                                class="fa-solid fa-circle-minus text-danger fs-4"
                                              ></i>
                                            </span>
                                          } @else {
                                            <div
                                              class="pt-2"
                                              (click)="
                                                openCommentTemplate(
                                                  commentRef,
                                                  item
                                                )
                                              "
                                            >
                                              <button
                                                class="btn btn-secondary btn-sm"
                                              >
                                                Add Remarks
                                              </button>
                                            </div>
                                          }
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                                  @if (
                                    [".mp4", ".mov", ".webm", ".mkv"].includes(
                                      item?.file_extension
                                    )
                                  ) {
                                    <video
                                      controls
                                      style="
                                        max-height: 100%;
                                        max-width: 100%;
                                        display: flex;
                                        width: 100%;
                                      "
                                    >
                                      <source
                                        src="{{ item?.file }}"
                                        type="video/mp4"
                                      />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  } @else {
                                    <img
                                      (click)="onOpenImage($event, item)"
                                      src="{{ item?.file }}"
                                      style="
                                        max-height: 100%;
                                        max-width: 100%;
                                        display: flex;
                                      "
                                    />
                                  }
                                </div>
                              </div>
                            </ng-container>
                          } @else {
                            <ng-container>
                              <div class="row row-cols-2">
                                <div class="col">
                                  <div class="row row-col-1row-col-lg-2">
                                    <div class="col">
                                      <div
                                        style="font-weight: 600"
                                        class="key-value d-flex gap-1"
                                      >
                                        {{
                                          item?.updated_datetime
                                            | date: "dd MMM yyyy HH:mm"
                                        }}
                                        <span
                                          (click)="
                                            editEventTimeStamp(
                                              item,
                                              eventTimepStampUpdateTemplateRef
                                            )
                                          "
                                          ><i
                                            class="fa-solid fa-pen-to-square text-secondary fa-2x"
                                          ></i
                                        ></span>
                                        @if (
                                          [1, 2, 7].includes(item?.event_action)
                                        ) {
                                          <span
                                            class="ms-1"
                                            (click)="
                                              deleteRestoreUserUpdate({
                                                event: item,
                                                type: item?.is_deleted
                                                  ? 'restore'
                                                  : 'delete',
                                              })
                                            "
                                          >
                                            @if (item?.is_deleted) {
                                              <span>
                                                <i
                                                  class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                                                ></i>
                                              </span>
                                            } @else {
                                              <span>
                                                <i
                                                  class="fs-5 fa-solid fa-circle-minus text-danger"
                                                ></i>
                                              </span>
                                            }
                                          </span>
                                        }
                                      </div>
                                      <!-- GPS ACCURACY NOTIFICATION-->
                                      @if (item?.gps?.source) {
                                        <div class="warning distance">
                                          @if (item?.gps?.source == 1) {
                                            Location may not be accurate.
                                          } @else if (item?.gps?.source == 2) {
                                            Location is an approximation only.
                                          }
                                        </div>
                                      }
                                    </div>
                                    <div class="col">
                                      <div
                                        style="
                                          display: flex;
                                          align-items: center;
                                          gap: 0.75rem;
                                          margin-bottom: 0.5rem;
                                        "
                                      >
                                        <span class="uppercase key-value">{{
                                          item.action
                                        }}</span>
                                        <div style="display: flex !important">
                                          @if (item?.event_action == 12) {
                                            <img
                                              src="https://app.guardtracker.com.au/assets/images/NFC_logo.avif"
                                              alt="NFC Logo"
                                              width="20"
                                              height="20"
                                              style="
                                                width: 20px !important;
                                                height: 20px !important;
                                                margin-right: 5px !important;
                                              "
                                            />
                                          }
                                          @if (item?.event_action == 6) {
                                            <img
                                              src="https://app.guardtracker.com.au/assets/images/qr-code-logo.avif"
                                              alt="QR Logo"
                                              width="20"
                                              height="20"
                                              style="
                                                width: 20px !important;
                                                height: 20px !important;
                                                margin-right: 5px !important;
                                              "
                                            />
                                          }
                                        </div>
                                      </div>
                                      <div class="gt-multi-line">
                                        {{ item.detail }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col">
                                  @if (item?.gps?.lat && item?.gps?.lon) {
                                    <div style="margin-bottom: 2rem">
                                      <div class="key-label text-secondary">
                                        Event Location
                                      </div>
                                      <div
                                        style="
                                          max-width: 100%;
                                          height: 150px;
                                          object-fit: none;
                                        "
                                        class="small"
                                      >
                                        <gtapp-map-leaflet
                                          [customMapConfig]="{
                                            showSimpleStaticMap: true,
                                          }"
                                          [latLon]="{
                                            markerTooltip: item?.event_by,
                                            lat: item?.gps?.lat,
                                            lon: item?.gps?.lon,
                                          }"
                                          [mapId]="'map_' + i"
                                        ></gtapp-map-leaflet>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                              <!--OTHER EVENTS THAT HAVE LOCATION (QR & NFC)-->
                            </ng-container>
                          }
                        </div>
                      }
                    }
                  </div>
                }
                @if (promptFileDataUrls?.length && !showSummaryOnly) {
                  @for (promptFile of promptFileDataUrls; track $index) {
                    <div [id]="'mobile_form_detail' + promptFile?.file_id">
                      <ng-container>
                        <div class="d-flex mb-2">
                          <div
                            [ngClass]="
                              largeView
                                ? 'w-25 small pe-1 pb-3'
                                : 'w-50 small pe-1 pb-3'
                            "
                          >
                            <!--SECTION:  PHOTO COMMENT/NOTES-->
                            <div class="d-inline">
                              <div
                                style="color: #00538d"
                                class="gt-multi-line cursor-pointer text-decoration-underline"
                                (click)="
                                  scrollToSection(
                                    $event,
                                    'mobile_form_summary' + promptFile?.file_id
                                  )
                                "
                              >
                                @if (promptFile?.description) {
                                  <span>
                                    {{ promptFile?.description }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                            @if (
                              [".mp4", ".mov", ".webm", ".mkv"].includes(
                                promptFile?.file_extension
                              )
                            ) {
                              <video autoplay>
                                <source
                                  src="{{ promptFile?.file_url }}"
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            } @else {
                              <img
                                (click)="onOpenImage($event, promptFile)"
                                src="{{ promptFile?.file_url }}"
                                style="
                                  max-height: 100%;
                                  max-width: 100%;
                                  display: flex;
                                "
                              />
                            }
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  }
                }
              </ng-container>
            </div>
          </ng-container>
        } @else {
          <ng-container>
            @if (largeView) {
              <gtapp-gt-table
                [desktopTableBackendData]="userEvents"
                [desktopTableDetails]="userEventDetailsTableView"
                (rowClick)="onTableRowClick($event)"
                (sortColumn)="sortColumn($event)"
                (searchColumn)="searchColumn($event)"
                [tableStyle]="tableStyle"
                [otherParams]="otherParams"
                (paginationChange)="onChangePagination($event)"
              ></gtapp-gt-table>
            } @else {
              @if (!selectedEvent) {
                <gtapp-card-list
                  [mobileCardBackendData]="userEvents"
                  [mobileCardDetails]="userEventDetailsMobileView"
                  (rowClick)="onTableRowClick($event)"
                  (sortColumn)="sortColumn($event)"
                  (searchColumn)="searchColumn($event)"
                  [otherParams]="otherParams"
                  (paginationChange)="onChangePagination($event)"
                ></gtapp-card-list>
              }
            }
          </ng-container>
        }
      }
    </div>
  }
  @if (activeTab === uiTabs.tab3) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab3 ? 'active' : ''">
      @if (!selectedEvent || largeView) {
        <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
      }
      <div>
        @if (largeView) {
          <gtapp-gt-table
            [desktopTableBackendData]="userEvents"
            [desktopTableDetails]="userEventDetailsTableView"
            (rowClick)="onTableRowClick($event)"
            (sortColumn)="sortColumn($event)"
            (searchColumn)="searchColumn($event)"
            [otherParams]="otherParams"
            [tableStyle]="tableStyle"
            (paginationChange)="onChangePagination($event)"
          ></gtapp-gt-table>
        } @else {
          @if (!selectedEvent) {
            <gtapp-card-list
              [mobileCardBackendData]="userEvents"
              [mobileCardDetails]="userEventDetailsMobileView"
              (rowClick)="onTableRowClick($event)"
              (sortColumn)="sortColumn($event)"
              (searchColumn)="searchColumn($event)"
              [otherParams]="otherParams"
              (paginationChange)="onChangePagination($event)"
            ></gtapp-card-list>
          }
        }
      </div>
    </div>
  }
  @if (activeTab === uiTabs.tab4 && userPrompts?.length) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab4 ? 'active' : ''">
      @if (!selectedEvent || largeView) {
        <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
      }
      @if (
        (reportSiteClientLookup?.client?.data?.id ||
          reportSiteClientLookup?.site?.data?.id) &&
        selectedPromptIds?.length
      ) {
        @if (largeView) {
          <gtapp-gt-table
            [desktopTableBackendData]="userEvents"
            [desktopTableDetails]="userEventDetailsTableView"
            (rowClick)="onTableRowClick($event)"
            (sortColumn)="sortColumn($event)"
            (searchColumn)="searchColumn($event)"
            [otherParams]="otherParams"
            (paginationChange)="onChangePagination($event)"
          ></gtapp-gt-table>
        } @else {
          @if (!selectedEvent) {
            <gtapp-card-list
              [mobileCardBackendData]="userEvents"
              [mobileCardDetails]="userEventDetailsMobileView"
              (rowClick)="onTableRowClick($event)"
              (sortColumn)="sortColumn($event)"
              (searchColumn)="searchColumn($event)"
              [otherParams]="otherParams"
              (paginationChange)="onChangePagination($event)"
            ></gtapp-card-list>
          }
        }
      }
    </div>
  }
  @if (activeTab === uiTabs.tab8) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab8 ? 'active' : ''">
      @if (modifyReportRecipients) {
        <div class="row row-cols-1 col-lg-6 my-2">
          <div class="col">
            <ng-container>
              <gtapp-auto-complete
                [data]="siteListData"
                placeHolder="Select Site"
                searchKeyword="company_name"
                [itemTemplate]="siteLookupTemplate"
                (inputChanged)="onSiteSearch($event)"
                (selected)="onSelectReportModifySiteClient($event)"
                [initialValue]="reportModifySiteClient?.site?.company_name"
                inputId="siteId"
                [enableCloseOption]="true"
                (fieldCleared)="editField('site')"
                (inputFocused)="inputFocused('site')"
              >
              </gtapp-auto-complete>
              <ng-template #siteLookupTemplate let-item>
                <div>
                  <div class="fw-medium">
                    {{ item?.company_name }} [{{ item?.company?.company_name }}]
                  </div>
                  <div class="small-font text-secondary">
                    {{ item?.address?.full_address }}
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div class="col">
            <gtapp-auto-complete
              [data]="clientDropDownList"
              placeHolder="Select Client"
              searchKeyword="company_name"
              [itemTemplate]="clientLookupTemplate"
              (inputChanged)="onClientSearch($event)"
              (selected)="onSelectReportModifySiteClient($event, 'client')"
              [enableCloseOption]="true"
              [initialValue]="reportModifySiteClient?.client?.company_name"
              inputId="clientLookupId"
              (fieldCleared)="editField('client')"
              (inputFocused)="inputFocused('client')"
            >
            </gtapp-auto-complete>
            <ng-template #clientLookupTemplate let-item>
              <div>
                {{ item?.company_name }}
              </div>
            </ng-template>
          </div>
          @if (
            reportModifySiteClient?.site?.id ||
            reportModifySiteClient?.client?.id
          ) {
            <div class="my-2">
              <div>
                <dl>
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Scheduled Checkpoint Patrol Route Reports</dt>
                    </div>
                    <div class="d-flex align-items-center">
                      <span (click)="openSchedulerTemplate()" role="button">
                        <i
                          class="fa-solid fa-pen-to-square md-font-size text-secondary"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <dd>
                    @if (
                      reportModifySiteClient?.patrol_report_schedules?.length <
                      1
                    ) {
                      <div class="alert alert-warning mt-2">
                        No one is receiving patrol reports.
                      </div>
                    }
                    @if (
                      reportModifySiteClient?.patrol_report_schedules?.length >
                      0
                    ) {
                      <div class="small text-secondary">
                        <em>Reports for updates will be sent to:</em>
                      </div>
                    }
                    <table class="table table-hover">
                      <tbody>
                        @for (
                          schedule of reportModifySiteClient?.patrol_report_schedules;
                          track schedule
                        ) {
                          <tr
                            class="cursor-pointer"
                            (click)="openSchedulerTemplate(schedule)"
                          >
                            <td>
                              <div class="d-flex">
                                <div class="d-flex align-items-center me-3">
                                  <i
                                    class="fa-solid fa-calendar-days fa-2x"
                                  ></i>
                                </div>
                                <div class="flex-grow-1">
                                  <div>{{ schedule?.name }}</div>
                                  <div class="small-font">
                                    {{
                                      schedule?.schedule?.repeat_type
                                        | titlecase
                                    }}
                                    &#64;
                                    {{ schedule?.mail_time }}
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </dd>
                </dl>
              </div>
            </div>
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Report Recipients</dt>
                  </div>
                  <div class="d-flex align-items-center">
                    <span
                      (click)="openJobReportContactTemplate()"
                      role="button"
                    >
                      <i
                        class="fa-solid fa-pen-to-square md-font-size text-secondary"
                      ></i>
                    </span>
                  </div>
                </div>
                <dd>
                  @if (
                    reportModifySiteClient?.job_report_recipients?.length < 1
                  ) {
                    <div class="alert alert-danger mt-2">
                      No recipients configured for reports.
                    </div>
                  }
                  <table class="table table-hover">
                    <tbody>
                      @for (
                        contact of reportModifySiteClient?.job_report_recipients;
                        track contact
                      ) {
                        <tr
                          class="cursor-pointer"
                          (click)="openSiteClientContactTemplate(contact)"
                        >
                          <td>
                            <div class="d-flex">
                              <div class="d-flex align-items-center me-3">
                                <i class="fa-solid fa-address-book fa-2x"></i>
                              </div>
                              <div class="flex-grow-1">
                                {{ contact?.full_name }}
                                <div class="small-font">
                                  {{ contact?.email }}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </dd>
              </dl>
            </div>
          }
        </div>
      } @else {
        <div class="my-2">
          <button
            class="btn btn-primary btn-lg rounded-0"
            (click)="modifyReportRecipients = true"
          >
            Modify Reports
          </button>
        </div>
        @if (reportContactDataListTemp?.length) {
          <div class="row col-12 col-lg-6 py-2">
            <div class="col-12 col-lg-6">
              <div class="input-group">
                <div class="form-floating">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Filter Contacts"
                    (input)="filterReportContacts('contact')"
                    [(ngModel)]="filterValue.contact"
                  />
                  <label>Filter By Contact</label>
                </div>
                @if (filterValue.contact) {
                  <span
                    class="input-group-text"
                    (click)="
                      filterValue.contact = ''; filterReportContacts('contact')
                    "
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                }
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="input-group">
                <div class="form-floating">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Filter Site"
                    (input)="filterReportContacts('site')"
                    [(ngModel)]="filterValue.site"
                  />
                  <label>Filter By Site</label>
                </div>
                @if (filterValue.site) {
                  <span
                    class="input-group-text"
                    (click)="
                      filterValue.site = ''; filterReportContacts('site')
                    "
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                }
              </div>
            </div>
          </div>
        }
        <div class="col-12 col-lg-6">
          @for (contact of reportContactDataList; track contact) {
            <div class="mb-2">
              <div
                class="d-flex align-items-center border shadow-sm p-2 rounded-2"
                (click)="expandCollapseContactTable(contact)"
                role="button"
              >
                <div class="d-flex me-3">
                  <i class="fa-solid fa-address-book fa-2x"></i>
                </div>
                <div class="flex-grow-1">
                  {{ contact?.contact_data?.full_name }}
                  <div class="small-font text-lowercase">
                    {{ contact?.contact_data?.email }}
                  </div>
                </div>
                @if (contact?.reports?.length) {
                  <div class="d-flex mx-3">
                    @if (contact?.contact_data?.expanded) {
                      <span>
                        <i class="fa-solid fa-chevron-up text-secondary"></i>
                      </span>
                    } @else {
                      <span>
                        <i class="fa-solid fa-chevron-down text-secondary"></i>
                      </span>
                    }
                  </div>
                }
              </div>
              @if (
                contact?.contact_data?.expanded && contact?.reports?.length
              ) {
                <div class="ps-lg-3">
                  <gtapp-gt-table
                    [desktopTableUIData]="contact?.reports"
                    [desktopTableDetails]="reportContactDataDetail"
                    [tableActionIcons]="reportContactDataDetailActionColumn"
                    (actionClick)="onReportContactActionIconClick($event)"
                    [otherParams]="{ paginationData: true }"
                  >
                  </gtapp-gt-table>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  @if (activeTab === uiTabs.tab6) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab6 ? 'active' : ''">
      <gtapp-subscriber-analytics></gtapp-subscriber-analytics>
    </div>
  }
  <div class="tab-content">
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab7 ? 'active' : ''">
      @if (activeTab === uiTabs.tab7) {
        <gtapp-time-attendance-report></gtapp-time-attendance-report>
      }
    </div>
  </div>
  <div class="tab-content">
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab5 ? 'active' : ''">
      @if (activeTab === uiTabs.tab5) {
        <gtapp-scheduled-reports></gtapp-scheduled-reports>
      }
    </div>
  </div>
</div>

@if (selectedEvent) {
  <gtapp-selected-event-detail
    [selectedEvent]="selectedEvent"
    selectedEventFrom="patrol"
    [extraCheck]="true"
    (goBack)="hideDetails()"
    (deleteRestoreUserUpdate)="deleteRestoreUserUpdate($event)"
    (editUserComment)="openCommentTemplate(commentRef, $event)"
  ></gtapp-selected-event-detail>
}

<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Recipients
      <span class="float-end" (click)="reportConfirmationTemplateRef.close()">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="d-flex gap-3 align-items-center flex-wrap mb-4">
      <button
        class="btn btn-sm btn-outline-primary"
        (click)="
          navigateToSiteClient(
            reportSiteClientLookup?.site?.data?.id ? 'site' : 'client',
            reportSiteClientLookup?.site?.data?.id ||
              reportSiteClientLookup?.client?.data?.id
          )
        "
      >
        Edit Recipients
      </button>
      @if (activeTab === uiTabs.tab2 && data?.source === "pdfRecipients") {
        <div>
          <label for="summaryOnlyField">
            <input
              class="form-check-input"
              type="checkbox"
              id="summaryOnlyField"
              [checked]="showSummaryOnly"
              (change)="
                showSummaryOnly = !showSummaryOnly;
                showCheckpointScanLocation = false
              "
            />
            Show Summary Only</label
          >
        </div>
        @if (qrNfcScanExists) {
          <div class="col">
            <label for="checkPointLocationShow">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkPointLocationShow"
                [checked]="showCheckpointScanLocation"
                (change)="
                  showCheckpointScanLocation = !showCheckpointScanLocation;
                  showSummaryOnly = false
                "
              />
              Show Scan Locations (QR/NFC)</label
            >
          </div>
        }
      }
    </div>

    @if (reportRecipientListData?.length) {
      <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3">
        @if (reportRecipientListData?.length > 1) {
          <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="
                selectedReportRecipientsListData?.length ===
                reportRecipientListData?.length
              "
              (change)="selectAllContacts($event)"
              id="selectAllBox"
            />
            <label for="selectAllBox"
              >Select All [{{ reportRecipientListData?.length }}]</label
            >
          </div>
        }
        @for (
          contact of reportRecipientListData;
          track contact;
          let i = $index
        ) {
          <div class="col form-check">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="!contact.isSnubbed"
              (change)="selectUnselectRecipients(contact)"
              id="check-{{ contact.id }}-{{ i }}"
            />
            <label
              class="form-check-label"
              for="check-{{ contact.id }}-{{ i }}"
            >
              {{ contact?.user_full_name }}

              <div class="small-font">
                {{ contact?.user_email }}
              </div>
            </label>
          </div>
        }
      </div>
    } @else {
      <div class="mb-2 alert alert-danger">
        There are no recipients configured for this site
      </div>
    }
    @if (selectedReportRecipientsListData?.length) {
      <dt class="text-end me-4 pt-2">
        Total Recipients Selected:
        <span class="fw-semibold fs-6">{{
          selectedReportRecipientsListData?.length
        }}</span>
      </dt>
    }

    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          type="button"
          (click)="reportConfirmationTemplateRef.close()"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          type="button"
          (click)="
            exportData(data?.source === 'pdfRecipients' ? 'pdf' : 'xlsx');
            reportConfirmationTemplateRef.close()
          "
          [disabled]="!selectedReportRecipientsListData?.length"
        >
          Send {{ data?.source === "pdfRecipients" ? "PDF" : "XLSX" }} Report
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #filterPromptDialog let-filterPromptDialog="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Prompts
      <span class="float-end" (click)="filterPromptDialog.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <ng-container>
      <table class="table">
        <tbody>
          @for (prompt of userPrompts; track prompt; let i = $index) {
            <tr class="cursor-pointer border-bottom">
              <td>
                <div
                  class="d-flex cursor-pointer"
                  (click)="selectUserPrompt(prompt)"
                >
                  <div>
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [checked]="prompt?.selected"
                    />
                  </div>
                  <div class="ms-2">
                    {{ prompt?.name }}
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            class="btn btn-dark w-100 btn-lg"
            (click)="filterPromptDialog.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            type="button"
            [disabled]="!selectedPromptIds?.length"
            class="btn btn-primary w-100 btn-lg"
            (click)="getEventLogData(); filterPromptDialog.close()"
          >
            Search
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #siteClientLookup let-siteClientLookupTempRef="dialogRef">
  <div class="d-flex flex-wrap gap-3 mb-3 align-start">
    <div class="flex-grow-1 flex-xl-grow-0">
      @if (reportSiteClientLookup?.site?.data?.id) {
        <div>
          <dl class="px-2 px-md-4">
            <dt>Site</dt>
            <dd (click)="editField('site')" class="link-edit">
              {{ reportSiteClientLookup?.site?.value }}

              @if (reportSiteClientLookup?.site?.data?.company?.company_name) {
                <span>
                  [{{
                    reportSiteClientLookup?.site?.data?.company?.company_name
                  }}]
                </span>
              }
            </dd>
          </dl>
        </div>
      } @else {
        <div [class.opacity-50]="reportSiteClientLookup?.site?.disabled">
          @if (!reportSiteClientLookup?.site?.hide) {
            <gtapp-auto-complete
              [data]="siteListData"
              placeHolder="Select Site"
              searchKeyword="company_name"
              [initialValue]="reportSiteClientLookup?.site?.value"
              [itemTemplate]="siteTemplate"
              (inputChanged)="onSiteSearch($event)"
              (selected)="onSelectSite($event)"
              inputId="siteId"
              [enableCloseOption]="true"
              (fieldCleared)="editField('site')"
              (inputFocused)="inputFocused('site')"
            >
            </gtapp-auto-complete>
          }
          <ng-template #siteTemplate let-item>
            @if (item?.key === 0) {
              <div>Create New Site</div>
            } @else {
              <div>
                <div class="fw-medium">
                  {{ item?.company_name }} [{{ item?.company?.company_name }}]
                </div>
                <div class="small-font text-secondary">
                  {{ item?.address?.full_address }}
                </div>
              </div>
            }
          </ng-template>
        </div>
      }
    </div>
    <div class="flex-grow-1 flex-xl-grow-0">
      @if (reportSiteClientLookup?.client?.data?.id) {
        <div>
          <dl class="px-2 px-md-4">
            <dt>Client</dt>
            <dd (click)="editField('client')" class="link-edit">
              {{ reportSiteClientLookup?.client?.value }}
            </dd>
          </dl>
        </div>
      } @else {
        <div [class.opacity-50]="reportSiteClientLookup?.client?.disabled">
          @if (!reportSiteClientLookup?.client?.hide) {
            <gtapp-auto-complete
              [data]="clientDropDownList"
              placeHolder="Select Client"
              searchKeyword="company_name"
              [itemTemplate]="clientTemplate"
              (inputChanged)="onClientSearch($event)"
              [initialValue]="reportSiteClientLookup?.client?.value"
              (selected)="onClientSelect($event)"
              [enableCloseOption]="true"
              inputId="clientLookupId"
              (fieldCleared)="editField('client')"
              (inputFocused)="inputFocused('client')"
            >
            </gtapp-auto-complete>
          }
          <ng-template #clientTemplate let-item>
            <div>
              {{ item?.company_name }}
            </div>
          </ng-template>
        </div>
      }
    </div>

    @switch (activeTab) {
      @case (uiTabs.tab2) {
        @if (userEvents?.length) {
          <div
            class="d-flex gap-2 flex-grow-1 flex-xl-grow-0 justify-content-center justify-content-xl-center"
          >
            @if (!previewPatrolReport && checkpointScanExists) {
              <button
                [disabled]="!(userEvents?.length && allowPDFExport)"
                class="btn btn-success btn-lg d-flex align-items-center gap-2"
                (click)="
                  openTemplate(reportConfirmationTemplate, 'xlRecipients')
                "
              >
                <i class="fa-regular fa-file-excel fs-4"></i>
              </button>
            }
            @if (previewPatrolReport) {
              <button
                [disabled]="!(userEvents?.length && allowPDFExport)"
                class="btn btn-lg d-flex gap-2 align-items-center btn-dark"
                (click)="
                  previewPatrolReport = !previewPatrolReport;
                  selectedEvent = null
                "
              >
                Back
              </button>

              <button
                [disabled]="!(userEvents?.length && allowPDFExport)"
                class="btn btn-danger btn-lg d-flex align-items-center gap-2"
                (click)="openTemplate(reportConfirmationTemplate)"
              >
                Get PDF Report <i class="fa-regular fa-file-pdf fs-4"></i>
              </button>
            } @else if (previewReportData) {
              <button
                [disabled]="!(userEvents?.length && allowPDFExport)"
                class="btn btn-lg d-flex gap-2 align-items-center btn-danger"
                (click)="
                  previewPatrolReport = !previewPatrolReport;
                  selectedEvent = null
                "
              >
                <i class="fa-regular fa-file-pdf fs-4"></i>
              </button>
            }
          </div>
        }
      }
      @case (uiTabs.tab3) {
        <div
          class="d-flex gap-2 flex-grow-1 flex-xl-grow-0 justify-content-center justify-content-xl-center"
        >
          <button
            [disabled]="!(userEvents?.length && allowPDFExport)"
            class="btn btn-danger btn-lg d-flex align-items-center gap-2"
            (click)="exportData('pdf')"
          >
            Get PDF Report <i class="fa-regular fa-file-pdf fs-4"></i>
          </button>
        </div>
      }
      @case (uiTabs.tab4) {
        <div
          class="d-flex gap-2 flex-grow-1 flex-xl-grow-0 justify-content-center justify-content-xl-center"
        >
          <button
            [disabled]="
              !reportSiteClientLookup?.client?.data?.id &&
              !reportSiteClientLookup?.site?.data?.id
            "
            class="btn btn-primary btn-lg"
            (click)="openTemplate(filterPromptDialog, 'mobileForms')"
          >
            Mobile Form(s)
          </button>

          <button
            [disabled]="!(userEvents?.length && allowPDFExport)"
            class="btn btn-danger btn-lg d-flex align-items-center gap-2"
            (click)="openTemplate(reportConfirmationTemplate)"
          >
            Get PDF Report <i class="fa-regular fa-file-pdf fs-4"></i>
          </button>
        </div>
      }
    }
  </div>
</ng-template>
<!-- ADD COMMENT  DIALOG -->
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newComment = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newComment"
          id="updateCommentBox"
        ></textarea>
        @if (newComment) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newComment = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousComment === newComment"
              (click)="editComment(data); commentRef.close()"
              [ngClass]="newComment ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newComment || previousComment === newComment"
              (click)="editComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #eventTimepStampUpdateTemplateRef
  let-eventTimepStampUpdateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update {{ data.name }} Time
      <span
        class="float-end"
        (click)="eventTimepStampUpdateTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.minDateTime || data?.maxDateTime) {
      <div class="small border border-1 text-secondary p-2 mb-2 rounded-2">
        {{ data.name }} time must be
        @if (data?.minDateTime && data?.maxDateTime) {
          between {{ data?.minDateTime | customDate: "d MMM y HH:mm" }} &
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else if (data?.maxDateTime) {
          less than {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else {
          greater than {{ data?.minDateTime | customDate: "d MMM y HH:mm" }}
        }
      </div>
    }
    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="data.newValue"
        (change)="changeStatusTimeStamp($event, data)"
        [min]="data?.minDateTime"
        [max]="data?.maxDateTime"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!--looped prompt template-->
<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <dl [id]="'mobile_form_summary' + dataItem?.file_id">
      @if (
        dataItem?.file_id && promptFileDataUrls?.length && !showSummaryOnly
      ) {
        <a
          class="cursor-pointer"
          (click)="
            scrollToSection($event, 'mobile_form_detail' + dataItem?.file_id)
          "
          style="color: #00538d"
        >
          <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        </a>
      } @else {
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
      }
      <dd>{{ dataItem | misc: "promptValue" }}</dd>
    </dl>
  }
  @for (option of dataItem?.options; track option) {
    <div class="nested-prompt">
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>
